import { Modal, Image } from "antd";
import styles from "@/styles/productDetail/addOnInfoModal.module.scss";
import getConfig from "next/config";
import Link from "next/link";
const { publicRuntimeConfig } = getConfig();
const imageDomain = publicRuntimeConfig.imageDomain;
interface AddOnInfoModalProps {
  open: boolean;
  onClose: () => void;
}

export default function AddOnInfoModal({ open, onClose }: AddOnInfoModalProps) {
  return (
    <Modal
      title=""
      width={913}
      style={{ height: 784, overflow: "auto" }}
      centered
      footer={null}
      open={open}
      onCancel={onClose}
    >
      <div className={styles["addon-info-model"]}>
        <div className="article-page" style={{ padding: 0 }}>
          <div className={styles["title"]}>Super Value Add-on Deals</div>
          <div className="content-title-box margin-top-32">
            <div className="content-point">1</div>
            <div className="title-text">Where to find Add-on Deals</div>
          </div>
          <div className="ask-title padding-top-24">
            Entry 1: In your Shopping Cart
          </div>
          <Image
            src={`${imageDomain}/add-on/Entry1-pc.png`}
            className="margin-top-12"
            width={"100%"}
            alt="Add-on Deals"
            preview={false}
          />
          {/* <div className="ask-title padding-top-24">
            Entry 2: On the Checkout page
          </div>
          <Image
            src={`${imageDomain}/add-on/Entry2-pc.png`}
            className="margin-top-12"
            width={"100%"}
            alt="Add-on Deals"
            preview={false}
          /> */}
          <div className="ask-title padding-top-24">
            Entry 2: On the Product Detail page
          </div>
          <Image
            src={`${imageDomain}/add-on/Entry3-pc.png`}
            className="margin-top-12"
            width={"100%"}
            alt="Add-on Deals"
            preview={false}
          />

          <div className="content-title-box margin-top-32">
            <div className="content-point">2</div>
            <div className="title-text">
              How to participate in Add-on Deals{" "}
            </div>
          </div>

          <div className="ask-title padding-top-24" style={{ paddingLeft: 24 }}>
            I. Introduction
          </div>
          <div className="answer-desc">
            You are eligible for &quot;Super Value Add-on Deals&quot; when selected items
            in your shopping cart meet the promotion criteria. Eligible users
            can purchase designated add-on products at a special discounted
            price.
          </div>

          <div className="ask-title padding-top-24" style={{ paddingLeft: 24 }}>
            II. Eligibility
          </div>
          <div className="answer-desc">
            1. Users must register an account on{" "}
            <Link href="https://www.crazysales.com.au/" legacyBehavior>
              <a rel="noopener noreferrer" target="_blank">
                https://www.crazysales.com.au/
              </a>
            </Link>{" "}
            or provide a valid email and delivery address during checkout to
            receive order confirmations.
          </div>
          <div className="answer-desc">
            2. Eligibility depends on the specific requirements displayed at the
            entry point of the add-on promotion in your shopping cart.
          </div>

          <div className="ask-title padding-top-24" style={{ paddingLeft: 24 }}>
            III. Access Points
          </div>
          <div className="answer-desc">
            Users can access the Add-on Deals section and select products via:
            <br />
            &bull; Below the main image on the Product Detail page.
            <br />
            &bull; Below the &quot;Checkout&quot; button in the Shopping Cart.
            <br />
            {/* &bull; Below the Order Summary on the Checkout page.
            <br /> */}
          </div>

          <div className="ask-title padding-top-24" style={{ paddingLeft: 24 }}>
            IV. How it Works
          </div>
          <div className="answer-desc">
            1. Adding to Cart: The Add-on Deals section will display a selection
            of products. Click the &quot;Add to Cart&quot; button next to an item to
            include it in your order.
          </div>
          <div className="answer-desc">
            2. Purchase Method: Add-on products must be purchased in the same
            transaction as the qualifying product. If the qualifying product is
            removed or not selected during checkout, the add-on eligibility and
            its promotional pricing will be void.
          </div>
          <div className="answer-desc">
            3. Purchase Limits:
            <br />
            {`\u2022 Limit of one (1) unit per add-on product per user. This applies to the specific option selected from the add-on list.`}
            <br />
            {`\u2022 The maximum number of add-on items per order is subject to the limits displayed on the page.`}
            <br />
            {`\u2022 Stock is limited and available on a "first-come, first-served" basis. Once an add-on item is out of stock, it cannot be purchased at the promotional price even if the criteria are met. We recommend completing your purchase as soon as possible.`}
            <br />
            {`\u2022 Add-on products are not eligible for further discounts (except for no minimum spend vouchers) and do not count towards the minimum spend requirements of other promotions.`}
            <br />
            {`\u2022 While add-on items are offered at significantly discounted prices, in rare cases, the Add-on Price may be higher than the final price a customer would pay when purchasing the same item separately with applicable discounts or vouchers.`}
          </div>
          <div className="answer-desc">
            4. Delivery: Add-on items and main products may be dispatched
            separately and arrive in different shipments.
          </div>

          <div className="ask-title padding-top-24" style={{ paddingLeft: 24 }}>
            V. Terms & Conditions
          </div>
          <div className="answer-desc">
            1. Region: This promotion is exclusive to users located in
            Australia.
          </div>
          <div className="answer-desc">
            2. CrazySales.com.au reserves the right to disqualify users and, if
            necessary, take legal action in the following circumstances:
            <br />
            {`\u2022 Use of bots, mass registrations, or any fraudulent activity that undermines fair competition.`}
            <br />
            {`\u2022 Violations of site rules, such as credit farming, malicious cash-outs, or wash trading.`}
            <br />
            {`\u2022 Lack of genuine purchasing intent, such as abusing the refund process to obtain items at low prices followed by excessive refund requests.`}
            <br />
            {`\u2022 Any other behaviour deemed by reasonable judgement to be exploitative rather than a standard consumer purchase.`}
          </div>

          <div className="answer-desc">
            {`3. CrazySales.com.au shall be exempt from liability in cases of Force Majeure (including but not limited to natural disasters, government orders to suspend activities, or major system failures/cyber-attacks).`}
          </div>

          <div className="answer-desc">
            {`4. CrazySales.com.au reserves the right to adjust these rules within the scope of the law. Any changes will be updated on this page. Matters not covered here are subject to the platform's general terms and conditions.`}
          </div>
        </div>
      </div>
    </Modal>
  );
}
